module.exports = __webpack_public_path__ + "static/media/cog-solid-r.47ac924a.svg";